import React, { useEffect, useState } from 'react';

import { useField } from 'formik';

import { Typography } from 'homer-web-app-components';

import classNames from 'classnames';

import { Radio, RadioToggle, TurnOnModal } from '../../../Common';

const MutateTaskShowByDefault = ({ name, ...props }) => {
  const [field, , fieldHelpers] = useField(name);

  return (
    <>
      <Typography
        style={{
          minWidth: '170px',
          textAlign: 'center',
        }}
        component="div"
        variant={Typography.THEME.VARIANTS.TITLE_SMALL}
      >
        Show by default
      </Typography>
      <RadioToggle
        {...props}
        className={classNames('mutate-task-active', props.className)}
      >
        <Radio
          value
          onChange={() => {
            fieldHelpers.setValue(true);
          }}
          checked={field.value === true}
          data-testid="yes"
        >
          Yes
        </Radio>
        <Radio
          value={false}
          onChange={() => {
            fieldHelpers.setValue(false);
          }}
          checked={field.value === false}
          data-testid="no"
        >
          No
        </Radio>
      </RadioToggle>
    </>
  );
};

export default MutateTaskShowByDefault;
